import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
  Tooltip,
  Grid,
} from "@mui/material";
import { Field } from "formik";
import InfoIcon from "@mui/icons-material/Info";
import {
  CURRENCY_MASK,
  MaskedInputWithErrorLabel,
} from "components/haven-design/form/inputs";
import { SegmentedControlWithLabelError } from "components/haven-design/form/radio/segmented-control";
import { FormProps } from "../types";

const sizeOptions = [...Array(12)].map((_, i) =>
  ({ label: (i + 1).toString(), value: (i + 1).toString() }));

const HouseholdStep: React.FC<FormProps> = () => (
  <div style={{ maxWidth: 430 }}>
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <SegmentedControlWithLabelError
          name="householdCount"
          legend="What is your current household size (including you)?"
          options={sizeOptions}
        />
      </Grid>
    </Grid>
    <Grid container spacing={2}>
      <Grid size={{ xs: 10 }}>
        <MaskedInputWithErrorLabel
          name="householdIncome"
          label="Gross Household Income"
          mask={CURRENCY_MASK}
        />
      </Grid>
      <Grid size={{ xs: 2 }}>
        <Tooltip enterTouchDelay={50} leaveTouchDelay={2500} title="Include income from jobs, Social Security, pensions, public benefits, etc. for ALL household members">
          <InfoIcon fontSize="small" style={{ margin: "12px -4px" }}/>
        </Tooltip>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Field name="householdIncomeFrequency">
          {({ field, meta }: any) => (
            <FormControl component="fieldset" variant="outlined" margin="dense" error={meta.touched && meta.error}>
              <label>Income Frequency</label>
              <RadioGroup variant="outlined" row {...field} >
                <FormControlLabel value="monthly" control={<Radio />} label="Per month" />
                <FormControlLabel value="yearly" control={<Radio />} label="Per year" />
              </RadioGroup>

              {meta.touched && meta.error && (
                <FormHelperText className="color-hc-error">
                  {meta.error}
                </FormHelperText>
              )}
            </FormControl>
          )}
        </Field>
      </Grid>
    </Grid>
  </div>
);

export default HouseholdStep;
